import React from "react";
import { View, Image, SafeAreaView, ScrollView, StyleSheet } from 'react-native'
import styles from "../../styles";
import Header from "../../components/Header";
import {not_connect_graphic} from "../../assets";
import Button from "../../components/form/Button";
import localize from "../../localize";

export default function Pagenotfound(props) {

    const goBacktoHome = () => {
        props.history.push("dashboard")
    }

    return (
        <SafeAreaView style={styles.container}>
            <Header title="404" goBack={() => props.history.push("/")} />
            <ScrollView style={{ paddingHorizontal: 50 }}>
                <Image
                    style={pageStyles.img}
                    resizeMode="contain"
                    source={not_connect_graphic} />
                <Button
                    title={localize.Go_to_home}
                    size="small"
                    onPress={goBacktoHome}
                />
                <View style={pageStyles.divider} />
                <Button
                    title={localize.Go_Back}
                    size="small"
                    variant="outline"
                    onPress={() => props.history.goBack()}
                />
            </ScrollView>
        </SafeAreaView>

    )
}
const pageStyles = StyleSheet.create({
    img: {
        width: "90%",
        height: 220,
        alignSelf: 'center',
        marginVertical: 50
    },
    divider: {
        padding: 6
    },
})